import { render, staticRenderFns } from "./UploadFilebutton.vue?vue&type=template&id=072db2e8&scoped=true"
import script from "./UploadFilebutton.vue?vue&type=script&lang=js"
export * from "./UploadFilebutton.vue?vue&type=script&lang=js"
import style1 from "./UploadFilebutton.vue?vue&type=style&index=1&id=072db2e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072db2e8",
  null
  
)

export default component.exports